import React from "react";

interface PageShellProps {
  children: React.ReactNode;
}

export const PageShell: React.FC<PageShellProps> = ({ children }) => {
  return <div className="min-h-screen bg-white dark:bg-slate-950">{children}</div>;
};
